import { Alert, Typography } from 'antd';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { environment } from '@environment';
import { useLocation } from 'react-router-dom';
import { Paths } from 'src/app.paths';
import { Agents, currentAgent } from 'src/services/utils';

export const Banner = () => {
    const { pathname } = useLocation();
    const [show, setShow] = useState<boolean>(false);
    const hasExtension = useRef<boolean>(false);

    useEffect(() => {
        chrome?.runtime?.sendMessage(
            environment.extensionId,
            {
                target: 'ServiceWorker',
                type: 'ping',
            }
        ).then(r => hasExtension.current = r === 'pong');
        setTimeout(() => setShow(!hasExtension.current && (currentAgent === Agents.Chrome || currentAgent === Agents.Edge)), 100);
    }, []);

    return show && pathname.startsWith(Paths.Workspace) && <Alert
        title={<span>Попробуйте <Typography.Link href={Paths.Extension}>расширение</Typography.Link> для записи встреч</span>}
        type='info'
        banner
        showIcon={false}
        className='top-banner'
        style={{ animation: 'fadeInSlideUp 0.5s ease-out forwards' }}
    />;
};
